import OrdersService from '@cabinet/services/api/orders'

const options = {
  layout: {
    type: 'accordion',
    defaultCollapsed: false,
    radios: true,
    spacedAccordionItems: false
  }
};

function normalizeCountryToISO2(value) {
  if (!value) return undefined;

  const v = String(value).trim();

  // Якщо вже ISO2
  if (/^[A-Za-z]{2}$/.test(v)) return v.toUpperCase();

  // Мінімальний мапінг під твої кейси
  const map = {
    // Ukraine
    ukraine: "UA",
    україна: "UA",

    // USA
    usa: "US",
    "united states": "US",
    "united states of america": "US",

    // Great Britain
    uk: "GB",
    "great britain": "GB",
    "united kingdom": "GB",

    // Canada
    canada: "CA",
    канада: "CA",
  };

  const key = v.toLowerCase();
  return map[key];
}

export default class clientSecret {
  constructor(summ, key, clientSecret, instance, type, payment, redirect, billing_details) {
    this.summ = summ
    this.stripeKey = key
    this.clientSecret = clientSecret
    this.stripe = null
    this.paymentRequest = null
    this.instance = instance
    this.product = {}
    this.type = type || ""
    this.payment = payment
    this.redirect = redirect
    this.billing_details = billing_details
    const { first_name, last_name, city, country, address_line_1: line1, address_line_2: line2, zipcode: postal_code, subdivision: state,  } = this.billing_details.billing_address
    this.name = `${first_name} ${last_name}`
  }
  getId(key) {
    return `${key}`
  }
  load() {
    const script = document.createElement('script')
    script.id = '_stripe-checkout-script'
    script.src = 'https://js.stripe.com/v3/'
    return script
  }

  loadSecureScript(product) {
    const script = this.load()
    script.onload = this.setPaymentRequest.bind(this)
    document.querySelector('head').append(script)
    this.product = product
  }
  loadScript() {
    const script = this.load()
    script.onload = this.setCheckout.bind(this)
    document.querySelector('head').append(script)
  }
  checkPayment() {
    setInterval(() => {
      OrdersService.getPayment(this.payment).then(({ data }) => {
        if (data.status == "paid") {
          // this.submit(true)
          window.location.assign(data.order_redirect)
        }
      }, err => {
        console.log(err);
      })
    }, 2000)
  }
  setPaymentRequest() {
    this.stripe = Stripe(this.stripeKey, {
      apiVersion: "2022-08-01",
    })
    this.paymentRequest = this.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: this.product.name,
        amount: Number(this.summ * 100),
      },
      requestPayerName: true,
      requestPayerEmail: true,
    })
    
    const form = document.getElementById(this.getId('payment-form'))
    this.paymentRequest.on('paymentmethod', (ev) => {
      form.classList.add('form-loader')
      // Confirm the PaymentIntent without handling potential next actions (yet).
      const { first_name, last_name, city, country, address_line_1: line1, address_line_2: line2, zipcode: postal_code, subdivision: state,  } = this.billing_details.billing_address
      this.stripe.confirmCardPayment(this.clientSecret, {
        payment_method: {
          id: ev.paymentMethod.id,
          billing_details: {
            "address": {
              city,
              country,
              line1,
              line2,
              postal_code,
              state,
            },
            "email": this.billing_details.email,
            "name": this.name,
            "phone": this.billing_details.phone
          },
        }
      }, {handleActions: false}).then(({paymentIntent, error: confirmError}) => {

        if (confirmError) {
          // Report to the browser that the payment failed, prompting it to
          // re-show the payment interface, or show an error message and close
          // the payment interface.
          ev.complete('fail');
          form.classList.remove('form-loader')
          const messageContainer = document.querySelector(`#${this.getId('error-message')}`)
          messageContainer.textContent = confirmError.message + ' ' + confirmError.decline_code
          OrdersService.updatePaymentError(this.payment, { transaction_status: confirmError.decline_code })
        } else {
          // Report to the browser that the confirmation was successful, prompting
          // it to close the browser payment method collection interface.
          ev.complete('success');
          // Check if the PaymentIntent requires any actions and, if so, let Stripe.js
          // handle the flow. If using an API version older than "2019-02-11"
          // instead check for: `paymentIntent.status === "requires_source_action"`.
          if (paymentIntent.status === "requires_action") {
            // Let Stripe.js handle the rest of the payment flow.
            this.stripe.confirmCardPayment(this.clientSecret).then(function({error}) {
              if (error) {
                form.classList.remove('form-first_nameloader')
                const messageContainer = document.querySelector(`#${this.getId('error-message')}`)
                messageContainer.textContent = error.message + ' ' + error.decline_code
                // The payment failed -- ask your customer for a new payment method.
                OrdersService.updatePaymentError(this.payment, { transaction_status: confirmError.decline_code })
              } else {
                // The payment has succeeded.
                // form.classList.remove('form-loader')
                
                this.checkPayment()
              }

            })
          } else {
            // The payment has succeeded.
            // form.classList.remove('form-loader')
            this.checkPayment()
          }
        }
      })
    });
    this.createPaymentBtns()
  }
  
  createPaymentBtns() {
    setTimeout(() => {
      const form = document.getElementById(this.getId('payment-form'))
      form.classList.add('form-loader')
      this.elements = this.stripe.elements({ clientSecret: this.clientSecret, loader: 'always', locale: 'en' })
      const options = {
        amount: Number(this.summ * 100),
        currency: 'USD',
        paymentMethodTypes: ['affirm'],
        // the country that the end-buyer is in
        countryCode: 'US'
      };
      const prButton = this.elements.create('paymentRequestButton', {
        paymentRequest: this.paymentRequest,
      })
      this.paymentRequest.canMakePayment().then((result) => {
        if (result) {
          prButton.mount(this.getId('#payment-element'))

        } else {
          document.getElementById(this.getId('payment-element')).innerText = 'Apple Pay or Google Pay is not available on this device'
        } 
        form.classList.remove('form-loader')
      })
    }, 1000)
  }
  setCheckout() {
    this.stripe = Stripe(this.stripeKey, {
      apiVersion: "2022-08-01",
    })
    this.createElements()
  }
  createElements() {
    this.elements = this.stripe.elements({ clientSecret: this.clientSecret, loader: 'always', locale: 'en' })
    const paymentElement = this.elements.create('payment')
    paymentElement.mount(this.getId('#payment-element'))
    // this.completeWithSaved(this.payment_method)
  }
  complete() {
    const form = document.getElementById(this.getId('payment-form'))
    setTimeout(() => {
      form.classList.remove('form-loader')

    }, 2000)

    form.addEventListener('submit', (event) => {
      if (!(Array.from(document.getElementById('payment-element').children).length)) return 
      form.classList.add('form-loader')

      event.preventDefault()

      const countryISO2 = normalizeCountryToISO2(
        this.billing_details.billing_address.country
      );
      this.stripe.confirmPayment({
        //`Elements` instance that was used to create the Payment Element
        elements: this.elements,
        confirmParams: {
          return_url: window.location.href,
          payment_method_data: {
            billing_details: {
              name: `${this.billing_details.billing_address.first_name} ${this.billing_details.billing_address.last_name}`,
              email: this.billing_details.email,
              phone: this.billing_details.phone,
              address: {
                line1: this.billing_details.billing_address.address_line_1,
                line2: this.billing_details.billing_address.address_line_2,
                city: this.billing_details.billing_address.city,
                state: this.billing_details.billing_address.subdivision,
                postal_code: this.billing_details.billing_address.zipcode,
                country: countryISO2,
              }
            }
          }
        },
        redirect: "if_required"
      }).then((res) => {
        if (res.error) {
          // This point will only be reached if there is an immediate error when
          // confirming the payment. Show error to your customer (for example, payment
          // details incomplete)
          form.classList.remove('form-loader')
          const messageContainer = document.querySelector(this.getId('#error-message'))
          messageContainer.textContent = res.error.message + ' ' + res.error.decline_code
          OrdersService.updatePaymentError(this.payment, { transaction_status: res.error.decline_code })
        } else {
          this.checkPayment()
          // Your customer will be redirected to your `return_url`. For some payment
          // methods like iDEAL, your customer will be redirected to an intermediate
          // site first to authorize the payment, then redirected to the `return_url`.
        }

      })

    })
  }
  completeWithSaved(payment_method) {
    this.stripe.confirmCardPayment(this.clientSecret, {
      payment_method: payment_method
    }).then(function(result) {
      if (result.error) {
        // Show error to your customer
      } else {
        if (result.paymentIntent.status === 'succeeded') {
          // The payment is complete!
        }
      }
    });
  }

}
